import { Modal } from 'antd';

const confirmDialog = ({ title = 'Please confirm', content, okText = 'Confirm', cancelText = 'Cancel' }) =>
  new Promise((resolve) => {
    Modal.confirm({
      title,
      content,
      okText,
      cancelText,
      className: 'app-confirm-modal',
      centered: true,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });

export { confirmDialog };
